// extracted by mini-css-extract-plugin
export var content = "hero-module--content--3Zx_S";
export var jsAnimInit = "hero-module--jsAnimInit--3zuAj";
export var title_extra = "hero-module--title_extra--1f4S4";
export var section = "hero-module--section--2BAJ3";
export var description = "hero-module--description--2ck30";
export var title = "hero-module--title--30CdO";
export var media = "hero-module--media--fGcDQ";